import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "field" }
const _hoisted_2 = { class: "field" }
const _hoisted_3 = { style: {"text-align":"center"} }
const _hoisted_4 = ["disabled"]

import { InsuranceUser } from "@/models/InsuranceUser";
import { onMounted, ref, computed, onUnmounted } from "vue";
import { useQuoteStore } from "@/stores/root/quote";
import useModal from "@/hooks/useModal";
import { storeToRefs } from "pinia";


export default /*@__PURE__*/_defineComponent({
  __name: 'AddUserModal',
  props: {
  name: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const props = __props;
const { toggleModal, onModalMounted, onModalDestroy } = useModal();
const modalClass = onModalMounted(props.name);
const user = ref(new InsuranceUser());
const quote = useQuoteStore();

onMounted(() => {
  user.value = new InsuranceUser();
});

onUnmounted(() => {
  onModalDestroy(props.name);
});

function addUser() {
  quote.checkout.roommates.push(user.value);
  toggleModal(props.name);
  user.value = new InsuranceUser();
}

function onShow() {
  // Reset user on new show
  user.value = new InsuranceUser();
}

const validated = computed(() => {
  return user.value.firstName && user.value.lastName;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(modalClass))
  }, [
    _createElementVNode("div", {
      class: "content",
      onModalClose: _cache[4] || (_cache[4] = ($event: any) => (_unref(toggleModal)(__props.name)))
    }, [
      _createElementVNode("span", {
        class: "close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(toggleModal)(__props.name)))
      }, "X"),
      _cache[7] || (_cache[7] = _createElementVNode("h4", { style: {"text-align":"center"} }, "Add Roommate", -1)),
      _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("div", _hoisted_1, [
        _cache[5] || (_cache[5] = _createElementVNode("label", { class: "tinylabel" }, [
          _createTextVNode(" First Name "),
          _createElementVNode("red", null, "*")
        ], -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((user.value.firstName) = $event)),
          type: "text"
        }, null, 512), [
          [_vModelText, user.value.firstName]
        ])
      ]),
      _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("div", _hoisted_2, [
        _cache[6] || (_cache[6] = _createElementVNode("label", { class: "tinylabel" }, [
          _createTextVNode(" Last Name "),
          _createElementVNode("red", null, "*")
        ], -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((user.value.lastName) = $event)),
          type: "text"
        }, null, 512), [
          [_vModelText, user.value.lastName]
        ])
      ]),
      _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
      _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
      _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          disabled: !validated.value,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (addUser()))
        }, "Add", 8, _hoisted_4)
      ])
    ], 32)
  ], 2))
}
}

})